import React from 'react';

import {
  Handshake as HandshakeIcon,
  Home as HomeIcon,
  MarkEmailRead as MarkEmailReadIcon,
  Notifications as NotificationsIcon,
  Password as PasswordIcon,
  PeopleAlt as PeopleAltIcon,
  Person as PersonIcon,
  Phonelink as PhonelinkIcon,
  Verified as VerifiedIcon,
  Work as WorkIcon,
  Workspaces as WorkspacesIcon,
  Wysiwyg as WysiwygIcon,
} from '@mui/icons-material';

import { appRoutes } from '@clearverify/constants';

import { BaseLayoutLeftMenu, LeftMenuLogo, MenuItem } from 'src/components/common';
import { useGlobalState } from 'src/hooks/shared';

export const LayoutLeftMenu: React.FC = () => {
  const { leftMenuDrawerState } = useGlobalState();

  return (
    <BaseLayoutLeftMenu
      leftMenuDrawerState={leftMenuDrawerState}
      menuItemsList={menuItems}
      myAccountItemsList={myAccountItemsList}
      rootRoute={appRoutes.inbox.index}
      logoutRoute={appRoutes.auth.logout}
      leftMenuLogo={<LeftMenuLogo showIcon={!leftMenuDrawerState.isOpened} />}
    />
  );
};

const menuItems: MenuItem[] = [
  {
    link: appRoutes.inbox.index,
    title: 'Home',
    icon: HomeIcon,
  },
  {
    link: appRoutes.verifiers.index,
    title: 'Verifiers',
    icon: VerifiedIcon,
  },
  {
    link: appRoutes.employees.index,
    title: 'Employees',
    icon: PeopleAltIcon,
  },
  {
    link: appRoutes.employers.index,
    title: 'Employers',
    icon: WorkIcon,
  },
  {
    link: appRoutes.peos.index,
    title: 'PEOs',
    icon: WorkspacesIcon,
  },
  {
    link: appRoutes.partnerships.index,
    title: 'Partnerships',
    icon: HandshakeIcon,
  },
  {
    link: appRoutes.reports.dataDisputes,
    title: 'Reports',
    icon: WysiwygIcon,
  },
  {
    link: appRoutes.emailTracker.index,
    title: 'Email Tracker',
    icon: MarkEmailReadIcon,
  },
];

const myAccountItemsList: Array<MenuItem> = [
  {
    link: appRoutes.account.personalInformation,
    title: 'Personal Information',
    icon: PersonIcon,
  },
  {
    link: appRoutes.account.notifications,
    title: 'Notifications',
    icon: NotificationsIcon,
    divider: true,
  },
  {
    link: appRoutes.account.security,
    title: 'Sign-in & Security',
    icon: PasswordIcon,
  },
  {
    link: appRoutes.account.setupMfa,
    title: 'Multi-factor Authentication',
    icon: PhonelinkIcon,
  },
];
